/*  
  TODO: TO BE DEPRECATED: This file doesn't seem to be in use anymore for Flights team.
  If packages team doesn't use this, we can remove it
*/
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { BaggageFeesLink } from '@pcln/fly-ui-components'
import { Box, Text, Flex } from 'pcln-design-system'

const DescriptionBox = styled(Box)`
  ${(props) => props.theme.flyQueries.tabletlg} {
    ${(props) => (props.shelfVariantName === 'THREESHELVES' ? 'width: 33.33%;' : '')}
  }
`

const NGSShelfHeader = styled(Flex)`
  height: 30px;
  ${DescriptionBox}:last-child {
    ${(props) => (props.shelfVariantName === 'THREESHELVES' ? 'display: none;' : '')}
  }
  ${(props) => props.theme.flyQueries.tabletlg} {
    ${DescriptionBox}:last-child {
      ${(props) => (props.shelfVariantName === 'THREESHELVES' ? 'display: inline-block;' : '')}
    }
  }
`

const LowerCaseBaggageFeesLink = styled(BaggageFeesLink)`
  text-transform: lowercase;
`

const PriceDisclosure = styled(Box)`
  ${(props) => props.theme.flyQueries.tablethd} {
    padding-left: 0px;
  }
`

const getShelfArray = (shelfVariantName) => {
  return shelfVariantName === 'THREESHELVES'
    ? ['MOST RESTRICTIVE', 'LESS RESTRICTIVE', 'EXTRA PERKS']
    : ['BASIC', 'STANDARD']
}

const FareBrandShelfHeader = ({ priceDisclosure, shelfVariantName }) => (
  <Flex mb={3}>
    <PriceDisclosure width={shelfVariantName === 'THREESHELVES' ? '45%' : '50%'} mr={2} pr={2} pl={2}>
      <Text.span fontSize={'10px'} regular data-autobot-element-id='LISTINGS_PRICE_DISCLAIMER'>
        {priceDisclosure}
        <LowerCaseBaggageFeesLink />.
      </Text.span>
    </PriceDisclosure>
    <NGSShelfHeader
      width={shelfVariantName === 'THREESHELVES' ? '55%' : '50%'}
      bg='background.darkest'
      color='text.lightest'
      pt={2}
      shelfVariantName={shelfVariantName}
      borderRadius='xl'
    >
      {getShelfArray(shelfVariantName).map((text, idx) => (
        <DescriptionBox width={1 / 2} shelfVariantName={shelfVariantName} key={idx}>
          <Text bold fontSize={'10px'} align='center'>
            {text}
          </Text>
        </DescriptionBox>
      ))}
    </NGSShelfHeader>
  </Flex>
)

FareBrandShelfHeader.propTypes = {
  priceDisclosure: PropTypes.string,
  shelfVariantName: PropTypes.string,
}

export default FareBrandShelfHeader
